module.exports = __webpack_public_path__ + "img/ex.8337b164.png";